import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogConfigData } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';
import { createLessee, isProjectSubjectValid, ProjectSubjectModel } from '@app/ps/models/project-subject.model';
import { Restangular } from 'ngx-restangular';

@Component({
  selector: 'lessee-edit',
  templateUrl: './lessee-edit.component.html',
})
export class LesseeEditComponent implements OnInit {

  lesseeId: number;
  lessee: ProjectSubjectModel;
  loading = true;

  constructor(
    private restangular: Restangular,
    private config: DialogConfig,
    private dialog: DialogRef,
  ) {
    this.lesseeId = (<DialogConfigData>config.data).lesseeId;
    this.onCreate = this.onCreate.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
  }

  ngOnInit() {
    if (this.lesseeId) {
      this.restangular
        .one('lessees', this.lesseeId)
        .get({ loadCollections: [ 'actingPersons' ] })
        .toPromise()
        .then(data => {
          this.lessee = data.plain();
          this.loading = false;
        });
    } else {
      this.lessee = createLessee();
      this.loading = false;
    }
  }

  onCreate(): Promise<any> {
    return this.restangular
      .all('lessees')
      .all('create')
      .post(this.lessee)
      .toPromise()
      .then(data => {
        this.dialog.close(data.plain());
      });
  }

  onUpdate(): Promise<any> {
    return this.restangular
      .one('lessees', this.lessee.id)
      .customPUT(this.lessee, '', { loadCollections: [ 'actingPersons' ] })
      .toPromise()
      .then(data => {
        this.dialog.close(data.plain());
      });
  }

  isValid() {
    return isProjectSubjectValid(this.lessee);
  }
}
